/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkAliasToBand
 */
export interface LinkAliasToBand {
    /**
     * 
     * @type {string}
     * @memberof LinkAliasToBand
     */
    aliasId: string;
    /**
     * 
     * @type {boolean}
     * @memberof LinkAliasToBand
     */
    isPermanentMember?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LinkAliasToBand
     */
    isMainPerformer?: boolean;
}

/**
 * Check if a given object implements the LinkAliasToBand interface.
 */
export function instanceOfLinkAliasToBand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;

    return isInstance;
}

export function LinkAliasToBandFromJSON(json: any): LinkAliasToBand {
    return LinkAliasToBandFromJSONTyped(json, false);
}

export function LinkAliasToBandFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkAliasToBand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aliasId': json['alias_id'],
        'isPermanentMember': !exists(json, 'is_permanent_member') ? undefined : json['is_permanent_member'],
        'isMainPerformer': !exists(json, 'is_main_performer') ? undefined : json['is_main_performer'],
    };
}

export function LinkAliasToBandToJSON(value?: LinkAliasToBand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alias_id': value.aliasId,
        'is_permanent_member': value.isPermanentMember,
        'is_main_performer': value.isMainPerformer,
    };
}

